/* tslint:disable */
/* eslint-disable */
/* @relayHash f95607baa94b950e7eea64ef9c610cb6 */

import { ConcreteRequest } from "relay-runtime";
export type AddUserToAutopilotContactsInput = {
    userId: string;
    sessionId: string;
    clientMutationId?: string | null;
};
export type addUserToAutopilotContactsMutationVariables = {
    input: AddUserToAutopilotContactsInput;
};
export type addUserToAutopilotContactsMutationResponse = {
    readonly addUserToAutopilotContacts: {
        readonly clientMutationId: string | null;
    } | null;
};
export type addUserToAutopilotContactsMutation = {
    readonly response: addUserToAutopilotContactsMutationResponse;
    readonly variables: addUserToAutopilotContactsMutationVariables;
};



const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "AddUserToAutopilotContactsPayload",
    "kind": "LinkedField",
    "name": "addUserToAutopilotContacts",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "clientMutationId",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "addUserToAutopilotContactsMutation",
    "selections": (v1/*: any*/),
    "type": "Mutations",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "addUserToAutopilotContactsMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "id": "ferrum/311.0.0-2021-04-21T17:34:53.450Z/addUserToAutopilotContactsMutation",
    "metadata": {},
    "name": "addUserToAutopilotContactsMutation",
    "operationKind": "mutation",
    "text": null
  }
};
})();
(node as any).hash = 'f94c4bd4ad3841be78a022b6d736e5cd';
export default node;
